import { FC, Children, isValidElement, SVGAttributes } from "react";

export interface ContentLoaderChildren extends SVGAttributes<SVGElement> {
  title?: string;
  uniqueKey?: string;
  children?: Child[] | Child;
}

interface Child extends SVGAttributes<SVGElement> {}

const ContentLoader: FC<ContentLoaderChildren> = ({
  width = 100,
  height = 100,
  uniqueKey,
  title,
  children,
}) => {
  const fixedId = uniqueKey || Math.random().toString(36).substring(6);
  const clipId = `${fixedId}-diff`;
  const gradientId = `${fixedId}-animated-diff`;
  const idAria = `${fixedId}-aria`;

  const coverImage = Children.toArray(children).find(
    (child) => isValidElement(child) && child.type === "image"
  );

  return (
    <svg width={width} height={height}>
      {title ? <title id={idAria}>{title}</title> : null}
      {coverImage}
      <rect
        x={0}
        y={0}
        width="100%"
        height="100%"
        fill="#374D62"
        fillOpacity="0.1"
        clipPath={`url(#${clipId})`}
      ></rect>
      <rect
        width="200%"
        height="100%"
        x="0%"
        y="0"
        fill={`url(#${gradientId})`}
        clipPath={`url(#${clipId})`}
      >
        <animate
          attributeName="x"
          values="-200%;200%"
          dur="2s"
          repeatCount="indefinite"
        ></animate>
      </rect>
      <defs>
        <clipPath id={clipId}>{children}</clipPath>
        <linearGradient id={gradientId}>
          <stop stopColor="#374D62" offset="0%" stopOpacity="0"></stop>
          <stop stopColor="#374D62" offset="10%" stopOpacity="0.1"></stop>
          <stop stopColor="#374D62" offset="40%" stopOpacity="0.2"></stop>
          <stop stopColor="#374D62" offset="60%" stopOpacity="0.2"></stop>
          <stop stopColor="#374D62" offset="90%" stopOpacity="0.1"></stop>
          <stop stopColor="#374D62" offset="100%" stopOpacity="0"></stop>
        </linearGradient>
      </defs>
    </svg>
  );
};

export default ContentLoader;
